export const errorIntensityChart = {
    series: [
    ],
    chartOptions: {
        chart: {
            height: 500,
            type: 'line',
            zoom: {
                enabled: true
            },
        },
        dataLabels: {
            enabled: false
        },
        // stroke: {
        //     width: [
        //         4,
        //         // 4,
        //         // 4
        //     ],
        //     curve: 'straight',
        // },
        // title: {
        //     text: 'Total daily emission intensity calculation error',
        //     align: 'left',
        //     style: {
        //         color: "#FFFFFF",
        //         fontSize: "14px",
        //         fontWeight: "bold",
        //         fontFamily: "Helvetica, Arial, sans-serif",
        //     },
        // },
        legend: {
            // tooltipHoverFormatter: function (val, opts) {
            //     return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
            // },
            tooltipHoverFormatter: function (val) {
                return val
            },
            position: 'right',
            labels: {
                colors: "#FFFFFF",
            },
        },
        markers: {
            size: 0,
            hover: {
                sizeOffset: 6
            }
        },
        xaxis: {
            categories: [],
            type: 'category',
            labels: {
                rotate: -45,
                style: {
                    colors: "#FFFFFF",
                    fontSize: "12px",
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                },
            },
            axisBorder: {
                show: false,
                color: "#FFFFFF",
            },
            axisTicks: {
                show: false,
                color: "#FFFFFF",
            },
        },
        yaxis: [{
            decimalsInFloat: 3,
            tickAmount: 5,
            tickPlacement: "between",
            title: {
                style: {
                    color: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Helvetica, Arial, sans-serif",
                },
            },
            labels: {
                style: {
                    colors: "#FFFFFF",
                    fontSize: "12px",
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                },
            },
            axisBorder: {
                show: false,
                color: "#FFFFFF",
            },
            axisTicks: {
                show: false,
                color: "#FFFFFF",
            },
        }, ],
        tooltip: {
            y: [{
                    title: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                // {
                //     title: {
                //         formatter: function (val) {
                //             return val
                //         }
                //     }
                // },
                // {
                //     title: {
                //         formatter: function (val) {
                //             return val;
                //         }
                //     }
                // }
            ]
        },
        grid: {
            borderColor: '#f1f1f1',
        },

    },



}
